export default [
    {
        path: 'coleta-agendada',
        component: () => import(
            /* webpackChunkName: 'exame-laboratorial-coleta-agendada' */
            '@/views/exame-laboratorial/coleta-agendada/Index'
        ),
        redirect: 'coleta-agendada/create',
        children: [
            {
                name: 'exame-laboratorial-coleta-agendada-create',
                path: 'create',
                props: (route) => ({
                    unidade: parseInt(route.query.unidade),
                    atendimentoUnidade: parseInt(route.query.atendimentoUnidade),
                    coleta: parseInt(route.query.coleta),
                    atendimentoColeta: parseInt(route.query.atendimentoColeta),
                }),
                component: () => import(
                    /* webpackChunkName: 'exame-laboratorial-coleta-agendada' */
                    '@/views/exame-laboratorial/coleta-agendada/Form.vue'
                ),
            },
        ],
    }
]